import * as R from 'ramda'

const BASE_PATH = ['db']

export const dbSelector = R.pathOr({}, BASE_PATH)
